import reducer from './ctaPromptReducer'
import actions from './ctaPromptActions'
import CTAPrompt from './containers/CTAPrompt'

export { actions, reducer, CTAPrompt }
